import classnames from 'classnames';
import React from 'react';
import axios from 'axios';
import to from 'await-to-js';
import cookies from 'js-cookie';
import { css } from '@emotion/core';
import { useSetState } from 'react-use';
import { useStaticQuery, graphql } from 'gatsby';

import Button from 'molecules/Button';
import Container from 'molecules/Container';
import Form, { WrappedForm } from 'organisms/Form';
import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import Select from 'molecules/Select';
import { TextInput } from 'molecules/Input';
import WithBGImage from 'molecules/WithBGImage';
import { buildSelectOptions } from 'lib/helpers';

/**
 * Page promo.
 */
export default function PagePromoNew( {
  assetBlurb,         // string.
  assetHeading,       // string.
  assetHighlights,    // array.
  ctaText,            // string.
  formBlurb,          //string.
  formHeading,          //string.
  label,          //string.
  lead,          //string.
  ls,          //string.
  lss,          //string.
  submittedText,      // string.
} ) {


  const { sfPicklist } = useStaticQuery( graphql`
    query {
      sfPicklist {
        pilotTypeOptions {
          label
          value
        }
      }
    }
  ` );

  const typeOptions = buildSelectOptions( {
    items:      sfPicklist.pilotTypeOptions,
    valueKey:   'value',
    contentKey: 'label',
    selectText: 'Select one',
  } );

  /* ------ = State. = --------------------------------------------------------------------- */
  const [ s, setState ] = useSetState( {
    iShowing: false,
    isClosed: false,
  } );

  React.useEffect( ()  => {

    if( typeof window === 'undefined' ) {
      return;
    }

    const path = window.location.pathname.replace( '/', '' );

    setTimeout( () => {
      window.sessionStorage.setItem( `saw_global_promo`, true );
    }, 3000 );

  }, [] );

  /* ------ = Output. = --------------------------------------------------------------------- */
  const topHeight = '74px';


  return(

    <div
    className="d-none d-lg-block"
    css={ css`
      width: 100%;
      height: calc( 100% + ${topHeight} );
      position: fixed;
      top: 0;
      left: 0;
      z-index: var( --z-page-promo );
      background: var( --blue-darkest );
      color: #fff;
      transform: translateY(100%);

      //------------------------------------ = Open/close.
      ${ s.isClosed && `
        transition: var( --trans-md );
        transform: translateY( 200% ) !important;
      `}

      .passed-breakpoint-sm & {
        ${ ! s.isShowing && ! s.isClosed && `
          transform: translateY( calc(100% - ( ${topHeight} * 2 ) ) );
          transition: var( --trans-md );
        `}
      }

      //------------------------------------ = Showing.
      ${ s.isShowing && `
        transform: translateY(calc(${topHeight} * -1));
      ` }
    ` }
    >
      <Container>

        { /* Top */ }
        <div className="d-flex align-items-center"
        css={ css`
          height: ${topHeight};
          padding-right: 2.5rem;

          .Btn {
            min-width: 120px;
            margin-left: auto;
            flex-shrink: 0;
          }
        ` }
        >
          <h4 className="d-none d-lg-block"
          css={ css`
            background: url( ${ require( '~static/images/logo-horizontal-white.svg' ) } );
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 130px auto;
            padding-top: 1.25rem;
            font-weight: 500;
            letter-spacing: .5px;
            font-family: var( --f-accent );
            font-style: italic;
            display: inline-block;
            vertical-align: middle;
            width: 185px;
            margin-right: 4%;
            margin-top: .5rem
          `}
          >
            { label }
          </h4>

          <p
          css={ css`
            padding-right: 2rem;
            font-family: var( --f-accent );
            font-size: 1.25rem;
            font-style: italic;
            margin-bottom: 0;
          `}
          >{ lead }
          </p>

          <Button
          className="ml-autp"
          size="sm"
          color="green"
          onClick={ () => setState( { isShowing: true } ) }
          >
            { ctaText }
          </Button>

          <button
          css={ css`
            position: absolute;
            top: 1.25rem;
            color: white;
            top: 1.25rem;
            right: 1rem;
            font-size: 1.75rem;
          `}
          onClick={ () => setState( { isClosed: true } ) }
          >
            <Icon type="close" />
          </button>

        </div>

      </Container>

      { /* Bottom */ }
      <WithBGImage
      css={ css`
        height: 100vh;
      `}
      image={ {
        src: require( '~static/images/branded-bg-dark.jpg' ),
      } }
      >

        <button
        css={ css`
          position: absolute;
          top: 1.25rem;
          right: 1rem;
          color: white;
          font-size: 1.75rem;
        ` }
        onClick={ () => setState( { isClosed: true } ) }
        >
          <Icon type="close" />
        </button>

        <div
        className="abs-centered"
        css={ css`
          width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        ` }
        >
          <Container size="sm">
            <div className="row align-items-center">

              { /* Content */ }
              <div className="col-7"
              css={ css`
                padding-right: 3rem;
              `}
              >
                <h3 className="h-lg"
                css={ css`
                  margin-bottom: 0.5rem;
                `}
                >
                  { assetHeading }
                </h3>
                <p className="p-lg">{ assetBlurb }</p>
                <div className="row text-center "
                css={ css`
                  color: white;
                  padding-top: 0.5rem;

                  .Img {
                    width: 80px;
                    height: 80px !important;
                    border-radius: 100%;
                    border: solid 4px var( --blue-brand );
                    padding: 1rem;
                    margin: 0 auto 0.5rem;

                    img {
                      filter: invert(1);
                    }
                  }

                `}
                >
                  { !! assetHighlights?.length && assetHighlights.map( hl => (
                    <div className="col-4">
                      <div>
                        <Image data={ hl.icon.asset } />
                        <h4 className="h-xxs">{ hl.heading }</h4>
                      </div>
                    </div>
                  ) ) }
                </div>
              </div>

              { /* Form */ }
              <div className="col-5 text-center">
                <div
                css={ css`
                  border-radius: var( --radius-md );
                  background: white;
                  padding: 1.5rem;
                  color: var( --black );

                  .Form {
                    text-align: left;
                  }
                `}
                >
                  <h4 className="h-md"
                  css={ css`
                    margin-bottom: 0.75rem;
                    line-height: 0.9;
                  `}
                  >
                    { formHeading }
                  </h4>
                  <p className="p-sm"
                  css={ css`line-height: 1.3;`}
                  >{ formBlurb }
                  </p>

                  <WrappedForm
                  memo={ null }
                  type="standard"
                  form={ function TheForm( formProps ) {

                    const { getFieldDecorator } = formProps.form;
                    const [ formState, setformState ] = useSetState( {
                      isProcessing: false,
                      submittedMessage: null,
                    } );

                    /**
                    * Handle submit.
                    */
                    const handleSubmit = async e => {
                      e.preventDefault();

                      setformState( {
                        isProcessing: true,
                      } );

                      formProps.form.validateFields( async ( errors, values ) => {

                        // Uh oh...
                        if( errors ) {
                          return setformState( {
                            isProcessing: false,
                          } );
                        }

                        // Submit.
                        if( typeof window === 'undefined' ) {
                          return;
                        }

                        const [ errs, responses ] = await axios.all( [
                          axios.post( `${window.FUNCTIONS_URL}/ac-create-lead`, {
                            email:      values.Email,
                            firstName:  values.FirstName,
                            ls:         ls,
                            lss:        lss,
                          } ),
                          axios.post( `${window.FUNCTIONS_URL}/sf-submit-form`, {
                            ...values,
                            Most_Recent_Lead_Source__c: ls,
                            Most_Recent_Lead_Source_Specific__c: lss,
                            Lead_Source_URL__c: window.location.href,
                            Ad_Source__c: cookies.get( 'adsource' ),
                          } ),

                        ] );
                        //
                        // if( errs ) {
                        //   setformState( {
                        //     isProcessing: false,
                        //     submittedMessage: {
                        //       type: 'error',
                        //       message: `We're sorry, there was an error submitting your form, please reach out to <a href="mailto:support@dartdrones.com"> support@dartdrones.com</a> for help.`,
                        //     }
                        //   } );
                        //   return console.warn( err );
                        // }

                        setformState( {
                          isProcessing: false,
                          submittedMessage: {
                            type: 'success',
                            message: submittedMessage
                          }
                        } );

                      } );

                    }

                    return(

                      <>
                        { !! formState.submittedMessage

                          ?

                            <Form.Submitted
                            { ...formState.submittedMessage }
                            />

                          :

                            <Form
                            onSubmit={ handleSubmit  }
                            >

                              <Form.Item label="First name">
                                { getFieldDecorator( 'FirstName', {
                                  rules: [ {
                                    required: true,
                                    message: 'Please enter your first name.',
                                  } ],
                                } )(
                                  <TextInput
                                  />
                                ) }
                              </Form.Item>
                              <Form.Item label="Email">
                                { getFieldDecorator( 'Email', {
                                  rules: [ {
                                    required: true,
                                    type: 'email',
                                    message: 'Please enter a valid email.',
                                  } ],
                                  validateTrigger: 'onBlur',
                                } )(
                                  <TextInput
                                  />
                                ) }
                              </Form.Item>
                              <Form.Item label="How do you use your drone?">
                                { getFieldDecorator( 'Pilot_Type__c', {
                                  rules: [ {
                                    required: true,
                                    message: 'Please select your primary interest.',
                                  } ],
                                  initialValue: '',
                                } )(
                                  <Select >{ typeOptions }</Select>
                                ) }
                              </Form.Item>

                              <Form.Item>
                                <Button
                                htmlType="submit"
                                color="green"
                                size="lg"
                                isBusy={ formState.isProcessing }
                                style={ { width: '100%' } }
                                >
                                  Access Course
                                </Button>
                              </Form.Item>


                            </Form>

                        }
                      </>

                    );


                  } }
                  />




                </div>

              </div>

            </div>
          </Container>
        </div>
      </WithBGImage>
    </div>

  )

}
// const PagePromoNew = React.memo( p => {
//
//   //alert( JSON.stringify( p ) );
//
//   // let Form = null;
//   // if( !! p.asset ) {
//   //   Form = require( 'organisms/PrimaryForm' ).default;
//   // }
//
//
//   /* ------ = State. = --------------------------------------------------------------------- */
//   const [ s, setState ] = useSetState( {
//     iShowing: false,
//     isClosed: false,
//   } );
//
//   /* ------ = Lifecycle. = --------------------------------------------------------------------- */
//   React.useEffect( ()  => {
//
//     if( typeof window === 'undefined' ) {
//       return;
//     }
//
//     const path = window.location.pathname.replace( '/', '' );
//
//     setTimeout( () => {
//       window.sessionStorage.setItem( `saw_promo_${path}`, true );
//     }, 3000 );
//
//   }, [] );
//
//   /* ------ = Output. = --------------------------------------------------------------------- */
//   const className = classnames( 'PagePromo', 'd-none', 'd-lg-block',  {
//     ['is-closed']: s.isClosed,
//     ['is-showing']: s.isShowing,
//   } );
//
//   return(
//
//     <div className={ className }>
//
//       <Container>
//         <div className="PagePromo__top d-flex align-items-center">
//           <h4 className="PagePromo__hding d-none d-lg-block">{ p.content.label }</h4>
//           <p className="PagePromo__lead">{ p.content.lead }</p>
//           <Button
//           className="PagePromo__cta ml-auto"
//           size="sm"
//           color="green"
//           onClick={ () => setState( { isShowing: true } ) }
//           >
//             { p.content.ctaText }
//           </Button>
//           <button
//           className="PagePromo__close"
//           onClick={ () => setState( { isClosed: true } ) }
//           >
//             <Icon type="close" />
//           </button>
//         </div>
//       </Container>
//
//       <div className="PagePromo__bottom">
//
//         <button
//         className="PagePromo__bottom-close"
//         onClick={ () => setState( {
//           isClosed: true,
//           isShowing: false,
//         } ) }
//         >
//           <Icon type="close" />
//         </button>
//
//         <Container
//         className="PagePromo__form"
//         size="sm"
//         >
//           <h4 className="PagePromo__form-hding">{ p.content.formHeading }</h4>
//           <p className="PagePromo__form-text">{ p.content.formText }</p>
//           <div className="PagePromo__form-form">
//             <PrimaryForm
//             hideMessageField={ true }
//             tracking={ p.tracking }
//             confirmation={ p.content.confirmationText }
//             submitText={ p.content.submitText }
//             withLabels={ false }
//             />
//           </div>
//         </Container>
//
//       </div>
//
//     </div>
//   );
//
// } );
// PagePromo.propTypes = propTypes;
//
// export default PagePromo;
